import React from "react";
import "./comingsoon.css";
import CloseIcon from "@mui/icons-material/Close";
const ComingSoon = ({onClose,
  title = "Something Amazing Is Coming",
  description =
    "We are working behind the scenes to bring you something powerful. Stay tuned.",
}) => {
  return (
    <section className="comingSoon" onClick={(e)=>e.stopPropagation()}>
      <button type="button" aria-label="Close coming soon" className="btnCloseComingSoon" onClick={(event) => { event.stopPropagation(); onClose?.(false); }}><CloseIcon style={{fontSize: "3.5rem"}}/></button>
      <div className="comingSoon__background">
        <span className="comingSoon__orb comingSoon__orb--one" />
        <span className="comingSoon__orb comingSoon__orb--two" />
        <span className="comingSoon__orb comingSoon__orb--three" />
      </div>

      <div className="comingSoon__grid" />

      <div className="comingSoon__container">
        <div className="comingSoon__badge">
          <span className="comingSoon__badgeDot" />
          <span>COMING SOON</span>
        </div>

        <div className="comingSoon__content">
          <div className="comingSoon__iconWrapper">
            <div className="comingSoon__icon">
              ✦
            </div>
          </div>

          <span className="comingSoon__eyebrow">
            WE ARE BUILDING SOMETHING SPECIAL
          </span>

          <h1 className="comingSoon__title">
            {title}
            <span className="comingSoon__titleAccent">.</span>
          </h1>

          <p className="comingSoon__description">
            {description}
          </p>

          <div className="comingSoon__status">
            <div className="comingSoon__statusTop">
              <span>Development Progress</span>
              <span>78%</span>
            </div>

            <div className="comingSoon__progress">
              <div className="comingSoon__progressBar">
                <span />
              </div>
            </div>
          </div>

          <div className="comingSoon__features">
            <div className="comingSoon__feature">
              <div className="comingSoon__featureIcon">
                ✓
              </div>

              <div>
                <strong>Powerful</strong>
                <span>Built for real workflows</span>
              </div>
            </div>

            <div className="comingSoon__feature">
              <div className="comingSoon__featureIcon">
                ✓
              </div>

              <div>
                <strong>Modern</strong>
                <span>Designed for simplicity</span>
              </div>
            </div>

            <div className="comingSoon__feature">
              <div className="comingSoon__featureIcon">
                ✓
              </div>

              <div>
                <strong>Reliable</strong>
                <span>Ready for your business</span>
              </div>
            </div>
          </div>

          <div className="comingSoon__notification">
            <div className="comingSoon__notificationIcon">
              ✉
            </div>

            <div className="comingSoon__notificationText">
              <strong>Stay tuned</strong>
              <span>
                We will notify you when this feature is ready.
              </span>
            </div>
          </div>
        </div>

        <div className="comingSoon__footer">
          <span>© 2026</span>
          <span className="comingSoon__footerLine" />
          <span>Built with purpose</span>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;